import { isWeb } from 'src/utils/platform';
import { DEFAULT_LIST_PAGE_SIZE, parseLimit, parseOffset, } from './listPagination';
/** Removes list pagination query params from the current URL (web only). */
export function clearListPaginationFromLocation() {
    if (!isWeb || typeof window === 'undefined') {
        return;
    }
    const url = new URL(window.location.href);
    url.searchParams.delete('offset');
    url.searchParams.delete('limit');
    const search = url.searchParams.toString();
    const next = url.pathname + (search ? `?${search}` : '');
    window.history.replaceState(window.history.state, '', next);
}
export function getPaginationFromLocation(defaultLimit) {
    if (!isWeb || typeof window === 'undefined') {
        return { offset: 0, limit: defaultLimit };
    }
    const params = new URLSearchParams(window.location.search);
    return {
        offset: parseOffset(params.get('offset')),
        limit: parseLimit(params.get('limit'), defaultLimit),
    };
}
export function resolvePaginationFromRoute(routeParams, defaultLimit = DEFAULT_LIST_PAGE_SIZE) {
    const hasRouteOffset = routeParams?.offset !== undefined &&
        routeParams?.offset !== null &&
        routeParams?.offset !== '';
    if (hasRouteOffset) {
        return {
            offset: parseOffset(routeParams?.offset),
            limit: parseLimit(routeParams?.limit, defaultLimit),
        };
    }
    return getPaginationFromLocation(defaultLimit);
}
